<template>
  <div>
    <!-- The dynamic list title that comes in as a prop -->
    <div class="majorTitle">
      Invoices
    </div>

    <div
      v-if="invoicesIsLoading && groupedInvoices.unpaid.invoices.length === 0"
      class="loading-container marginNormalTop"
    >
      <div>
        <i class="fa fa-spinner fa-spin fa-2x fa-fw" />
        <span class="sr-only">Loading...</span>
        <div>Loading...</div>
      </div>
    </div>

    <!-- Loop through the lists of grouped invoices -->
    <div
      v-for="group in groupedInvoices"
      v-else
      :key="group.title"
    >
      <!-- The title for this group of invoices -->
      <div class="minorTitle">
        {{ group.title }}
      </div>

      <!-- The list of items -->
      <ul v-if="group.invoices.length > 0">
        <!-- Loop through the invoices -->
        <li
          v-for="invoice in group.invoices"
          :id="'item-card-' + invoice.invoice_id"
          :key="invoice.invoice_id"
          class="itemRow"
        >
          <InvoiceCard :invoice_id="invoice.invoice_id" />
        </li>
      </ul>

      <!-- There are no invoices in this list -->
      <div
        v-else
        class="colorGrey textCenter"
      >
        No invoices.
      </div>
    </div>

    <!-- The interset observer that fires when it enters the viewport -->
    <Observer @intersect="onIntersect" />
  </div>
</template>

<script>
import InvoiceCard from '@/components/InvoiceCard'
import ShippingOrderCard from '@/components/ShippingOrderCard'
import Observer from '@/components/Observer'

export default {

	name: 'InvoiceList',

	components: {
		InvoiceCard,
		Observer,
		ShippingOrderCard
	},

	props: [
		'listTitle',
		'groupBy'
	],

	data () {
		return {
			'page': 0,
			'offset': 50
		}
	},

	computed: {
		/**
		 * List of customer invoices.
		 *
		 * This was formerly in mapState - can't use that due to Edge
		 *
		 * @public
		 */
		invoices: function () {
			return this.$store.state.invoices
		},
		/**
		 * List of customer shipping orders
		 * @public
		 */
		shippingOrders: function () {
			return this.$store.state.shippingOrders
		},
		/**
		 * Whether an api call to get our invoices is in progress
		 *
		 * @public
		 */
		invoicesIsLoading: function () {
			return this.$store.state.invoicesIsLoading
		},
		/**
		 * The invoices we are viewing right now
		 */
		groupedInvoices: function () {
			const self = this

			let tempInvoices = {}

			// we are grouping by selling and sold
			if (this.groupBy === 'paid_status') {
				tempInvoices.unpaid = {
					'title': 'Unpaid',
					'invoices': []
				}
				tempInvoices.paid = {
					'title': 'Paid',
					'invoices': []
				}
			}
			// loop through all of their invoices
			Object.keys(self.invoices).forEach(function (key) {
				// only include invoices if they are not a shipping order invoice, as
				// shipping order invoices show up under the ShippingOrderList component

				let tempInvoice = {
					'invoice_id': self.invoices[key].invoice_id,
					'target_url': self.invoices[key].card.target_url,
					'image': self.invoices[key].card.image,
					'title': self.invoices[key].card.title
				}

				// we are grouping by paid and unpaid
				// this invoice is unpaid
				if (self.invoices[key].paid_in_full === 'n') {
					tempInvoices.unpaid.invoices.push(tempInvoice)
				} else {
					// Paid
					tempInvoices.paid.invoices.push(tempInvoice)
				}
			})

			tempInvoices.paid.invoices = tempInvoices.paid.invoices.slice(0, ((this.page * this.offset) + this.offset))
			return tempInvoices
		},
		/**
		 * Whether fulfillment is needed.
		 *
		 * @public
		 * @returns boolean
		 */
		needsFulfillment: function () {
			return this.invoice.shipping_order_invoice === false && this.invoice.shipping_order_pick_up === false
		}
	},

	mounted () {
	},
	methods: {
		/**
		 * Navigates to an invoice
		 * @param {*} payload
		 */
		showInvoice (payload) {
			this.$store.dispatch('updateCurrentInvoice', payload)
			this.insertAccountMenu('Invoice')
		},
		/**
		 * Paginates list for the scroll Observer
		 */
		onIntersect () {
			this.page = this.page + 1
		}
	}
}

</script>

<style scoped></style>
